import { render, staticRenderFns } from "./HomeAddressModal.vue?vue&type=template&id=527b73c4&"
import script from "./HomeAddressModal.vue?vue&type=script&lang=js&"
export * from "./HomeAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports